import * as React from "react";
import { outlookEvent } from "../../Entity/OutlookEvent";
import "./event.scss";
import { Callout } from "office-ui-fabric-react/lib/Callout";
import { DirectionalHint } from "office-ui-fabric-react/lib/ContextualMenu";
/* import Moment from "react-moment"; */
import {
  Facepile,
  IFacepileProps,
  OverflowButtonType
} from "office-ui-fabric-react/lib/Facepile";
import { DateHelper } from "../../Helpers/DateHelper";

export interface IProps {
  data: outlookEvent;
  phrases;
}
export interface IContextualMenuState {
  DetailCalloutVisible?: boolean;
  beakWidth?: number;
}
export default class EventDetail extends React.Component<
  IProps,
  IContextualMenuState
> {
  public facepileProps: IFacepileProps = {
    personas: [],
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };
  private _menuButtonElement: HTMLElement | null;
  constructor(props) {
    super(props);
    this.state = {
      DetailCalloutVisible: false,
      beakWidth: 16
    };
  }
  public render() {
    const { DetailCalloutVisible, beakWidth } = this.state;

    this.facepileProps.personas = [];

    let name = this.props.data.organizer.emailAddress.name;
    let parts = name.split(" ");

    let AssingeeInitial = parts[0]
      .trim()
      .substr(0, 1)
      .toUpperCase();
    if (parts.length > 1) {
      AssingeeInitial += parts[1]
        .trim()
        .substr(0, 1)
        .toUpperCase();
    }
    let persion = {
      // imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
      imageInitials: AssingeeInitial,
      personaName: name,
      initialsColor: Math.floor(Math.random() * 15)
    };

    this.facepileProps.personas.push(persion);

    let start = new Date(this.props.data.start.dateTime);
    let end = new Date(this.props.data.end.dateTime);
    let addressurl=`#`;
    if(this.props.data.location.address){
      let fulladdress=this.props.data.location.displayName;
      if(!!this.props.data.location.address.street){
        fulladdress +=', '+this.props.data.location.address.street;
      }
      if(!!this.props.data.location.address.city){
        fulladdress +=', '+this.props.data.location.address.city;
      }
      if(!!this.props.data.location.address.postalCode){
        fulladdress +=' '+this.props.data.location.address.postalCode;
      }
      if(!!this.props.data.location.address.state){
        fulladdress +=' '+this.props.data.location.address.state;
      }
      if(!!this.props.data.location.address.countryOrRegion){
        fulladdress +=' '+this.props.data.location.address.countryOrRegion;
      }
     
      addressurl=`https://www.google.com/maps/dir//${fulladdress}`;
    } else if(this.props.data.onlineMeeting){
      addressurl=this.props.data.onlineMeeting.joinUrl;
    }
    
    
    let rowcss = "ms-Grid-row miparow " + "detailrow";
    // let editurl='https://outlook.office.com/calendar/item/'+encodeURIComponent(this.props.data.id);
    
    return (
      <div className="Event">
        
        
        <div
          ref={menuButton => (this._menuButtonElement = menuButton)}
          onClick={this._onMenuClicked}
          title={this.props.data.subject}
          className={["subject", "ellips"].join(" ")}
        >
          {this.props.data.subject}
          {DetailCalloutVisible ? (
            <Callout
              className="ms-Callout-callout"
              onDismiss={this._onCalloutDismiss}
              target={this._menuButtonElement}
              directionalHint={DirectionalHint.topAutoEdge}
              coverTarget={false}
              isBeakVisible={true}
              gapSpace={0}
              beakWidth={beakWidth}
            >
              <div className="detailcallout">
                <div
                  className={["ms-Callout-header", "eventdetailheader"].join(
                    " "
                  )}
                >
                  {this.props.data.subject}
                </div>
                <div className="ms-Callout-inner" style={{ padding: "10px" }}>
                  <div className="ms-Callout-content ms-Grid">
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <i
                          className={[
                            "ms-Icon ms-Icon--Clock",
                            "detailbodyicon"
                          ].join(" ")}
                        />
                        {/* <Moment format="DD MMM YY hh:mm A - ">
                          {start.toString()}
                        </Moment>
                        <Moment format=" hh:mm A">{end.toString()}</Moment> */}
                        {DateHelper.GetDisplayDatestring(start,true)} - {DateHelper.GetDisplayDatestring(end,true)}
                        {this.props.data.type == "occurrence" ? (
                          <i
                            className={[
                              "ms-Icon ms-Icon--SyncOccurence",
                              "eventtype"
                            ].join(" ")}
                          />
                        ) : this.props.data.type == "exception" ? (
                          <i
                            className={[
                              "ms-Icon ms-Icon--UnsyncOccurence",
                              "eventtype"
                            ].join(" ")}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <i
                          className={[
                            "ms-Icon ms-Icon--POI",
                            "detailbodyicon"
                          ].join(" ")}
                        />
                        <a href={addressurl} target='_blank'>{this.props.data.location.displayName}</a> 
                      </div>
                    </div>
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <Facepile
                          key={this.props.data.id}
                          {...this.facepileProps}
                        />
                      </div>
                    </div>
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <i
                          className={[
                            "ms-Icon ms-Icon--AlarmClock",
                            "detailbodyicon"
                          ].join(" ")}
                        />
                        {this.getRemindertime()}
                      </div>
                    </div>
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <i
                          className={[
                            "ms-Icon ms-Icon--List",
                            "detailbodyicon"
                          ].join(" ")}
                        />
                        <span dangerouslySetInnerHTML={this.rawbody()} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Callout>
          ) : null}
        </div>
      </div>
    );
  }
  private rawbody = () => {
    var rawMarkup = this.props.data.body.content;
    return { __html: rawMarkup };
  }
  private getRemindertime = () => {
    let value = "";
    let time = this.props.data.reminderMinutesBeforeStart;
    if (time >= 5 && time <= 59) {
      value = time + " minutes before";
    } else if (time / 60 >= 1 && time / 60 <= 12) {
      value = time / 60 + " hours before";
    } else if (time / 60 == 24) {
      value = "1 day before";
    } else if (time / 60 > 24) {
      value = "1 week before";
    }
    return value;
  };
  private _onCalloutDismiss = (): void => {
    this.setState({
      DetailCalloutVisible: false
    });
  };

  private _onMenuClicked = (): void => {
    this.setState({
      DetailCalloutVisible: !this.state.DetailCalloutVisible
    });
  };
}
